export default __webpack_public_path__ + "static/media/gallery-wip-motor-housing-assembly_01.c3461317.jpg";